const $ = jQuery.noConflict();

class ShowMoreExcerpt {
	constructor() {
        this.target = '.show-more-excerpt__button';
    }

    init() {
		this.bindEvents();
    }

    bindEvents() {
       $( document ).on( 'click', this.target, this.toggleShowMore );
	}

    toggleShowMore( event ) {   
        const parent = event.currentTarget.parentNode;
        parent.classList.toggle('active');

        if ( parent.classList.contains('active') ) {
            event.currentTarget.innerHTML = 'Show Less';
        } else {
            event.currentTarget.innerHTML = 'Show More';
        }
    }
}

export default new ShowMoreExcerpt();
